function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
import tasks from '@/js/tasks';
import { loginObj } from '@/services/base';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
console.log(configuration);
var appApis = null;
if (!configuration['search']) {
  appApis = axios.create({});
} else {
  appApis = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8050')
  });
}
var beforeMiddleware = function beforeMiddleware(config) {
  config.headers['Authorization'] = 'Bearer ' + window.userInfo.accessToken;
  return config;
};

// appApis.before(beforeMiddleware)
setupInterceptors(appApis);
export default {
  getBuscadorAtributos: function getBuscadorAtributos(valor) {
    if (valor.semantic_search) {
      tasks.lockScreen.lock();
      return appApis.get('/search-engine/attributes/search-vector?category=' + valor.category_comma + '&q=' + valor.q + '&per_page=' + valor.per_page + '&page=' + valor.page + '&not_null_without_value=' + valor.not_null_without_value + '&include_search_by_desc=' + valor.include_search_by_desc + '&include_search_by_extra_data=' + valor.include_search_by_extra_data + '&include_no_available=' + valor.include_no_available + '&company_code=' + valor.company_code + '&not_null_min=' + valor.not_null_min + '&not_null_max=' + valor.not_null_max).then(function (response) {
        tasks.lockScreen.unlock();
        return response.data;
      });
    } else {
      tasks.lockScreen.lock();
      return appApis.get('/search-engine/attributes/search?category=' + valor.category_comma + '&q=' + valor.q + '&per_page=' + valor.per_page + '&page=' + valor.page + '&not_null_without_value=' + valor.not_null_without_value + '&include_search_by_desc=' + valor.include_search_by_desc + '&include_search_by_extra_data=' + valor.include_search_by_extra_data + '&include_no_available=' + valor.include_no_available + '&company_code=' + valor.company_code + '&not_null_min=' + valor.not_null_min + '&not_null_max=' + valor.not_null_max).then(function (response) {
        tasks.lockScreen.unlock();
        return response.data;
      });
    }
  },
  getBuscadorAtributosEspecifico: function getBuscadorAtributosEspecifico(valor) {
    //console.log(valor)
    return appApis.get('/search-engine/attributes/search-specific?category=' + valor.category_comma + '&q=' + valor.q).then(function (response) {
      return response.data;
    });
  },
  postUpdateAvailable: function postUpdateAvailable() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    var key = 'api_key=' + process.env.VUE_APP_API_KEY;
    return appApis.post('/search-engine/attributes/update?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  postActualizarEmpresaCategoria: function postActualizarEmpresaCategoria(categoria, accion, company_code) {
    var login = loginObj();
    var body = {
      login: login,
      'accion': accion,
      'company_code': company_code,
      'categoria': categoria
    };
    console.log('body');
    console.log(body);
    var key = 'api_key=' + process.env.VUE_APP_API_KEY;
    return appApis.post('/search-engine/attributes/update_company_category?' + key, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  }
};